<template>
  <modal
    class="editDriver"
    name="editDriver"
    transition="pop-out"
    :width="modalWidth"
    :height="450"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.editDriverModal.title") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $t("text.editDriverModal.firstName") }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="text"
                    :placeholder="$t('text.editDriverModal.firstName')"
                    v-model="driverInfo.name"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form_input_section">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required"
                      >{{ $t("text.editDriverModal.lastName") }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="text"
                      :placeholder="$t('text.editDriverModal.lastName')"
                      v-model="driverInfo.lastName"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-6">
                <div class="form_input_section">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $t("text.editDriverModal.email") }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="text"
                      :placeholder="$t('text.editDriverModal.email')"
                      v-model="driverInfo.email"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form_input_section">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $t("text.editDriverModal.phoneNumber") }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="text"
                      :placeholder="$t('text.editDriverModal.phoneNumber')"
                      v-model="driverInfo.phone"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center mt-5">
              <button
                class="add_quick_fuel_btn"
                @click="editDriver($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.editDriverModal.title") }} <span></span>
              </button>
              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="35px"
                class="ml-3 loader"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "editDriver",
  props: ["driverInfo", "companyId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    closeEditDriverModal() {
      this.$modal.hide("editDriver");
    },
    editDriver($event) {
      $event.preventDefault();
      if (!this.driverInfo.name) {
        this.$toast.open({
          message: "Name is required",
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.driverInfo.lastName) {
        this.$toast.open({
          message: "Lastname is required",
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.driverInfo.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.validEmail(this.driverInfo.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.driverInfo.phone) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (
        this.driverInfo.phone.length < 10 ||
        this.driverInfo.phone.length > 13
      ) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      // let companyID;
      // if (localStorage.getItem("companyDetails") !== null) {
      //   companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      // }
      let data = {
        id: this.driverInfo.id,
        companyId: this.companyId,
        firstName: this.driverInfo.name,
        lastName: this.driverInfo.lastName,
        phone: this.driverInfo.phone,
        email: this.driverInfo.email,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Delivery/CompanyDriver`,
          data,
          configObject.authConfig()
        )
        // .post(
        //   `https://oh.epump.ng/Drivers/EditDriver/EditDriverDetails`,
        //   data,
        //   configObject.authConfig()
        // )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.closeEditDriverModal();
          this.$toast.open({
            message: this.$t("text.editDriverModal.successfullyEdited"),
            type: "success",
            duration: 5000,
          });
          this.$eventHub.$emit("getDrivers");
          data = null;
          // this.vehicle = {
          //   driver: "",
          //   phoneNo: "",
          //   type: "",
          //   carType: "",
          //   carModel: "",
          //   carYear: "",
          //   plateNumber: "",
          // };
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.closeEditDriverModal();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
